import axios from "@/utils/request";

function AI_IMPORT_TRANSLATE_POST(params) {
  return axios.post("/translation/BatchTranslation/aiImportLinkTranslatePost", {
    ...params
  });
}
function AI_IMPORT_LINK_TRANSLATE(params) {
  return axios.get("/translation/BatchTranslation/aiImportLinkTranslate", {
    params: params
  });
}

export default {
  AI_IMPORT_TRANSLATE_POST,
  AI_IMPORT_LINK_TRANSLATE
};
